import * as React from 'react';

import { ISpecialist } from '../../models/specialist';
import { StringLazyLoad, waitForImage } from '../../helpers/lazy_load_helper';
import { Link } from '../link/link';

const s = require('./specialist.css');

interface IProps {
  onClick(): void;
  specialist: ISpecialist;
  isRoundPhoto?: boolean;
  getSummary?: (spec: ISpecialist) => string;
}

const renderEmpty = (isRoundPhoto?: boolean) =>
  <div
    className={
      s['c-specialists-photo'] +
      (isRoundPhoto ? ' ' +
      s['c-specialists-photo-round'] : '')} />

export const Specialist = (props: IProps) =>
  <Link
        href={props.specialist.url}
        className={`${s['c-specialists-item']}`}
        onClick={() => props.onClick()}>
    <StringLazyLoad
      onLoad={() => waitForImage(props.specialist.imageUrl)}
      renderEmpty={() => renderEmpty(props.isRoundPhoto)}
      renderLoading={() => renderEmpty(props.isRoundPhoto)}
      renderLoaded={(imageUrl: string) =>
        <div
          className={
            s['c-specialists-photo'] +
            (props.isRoundPhoto ? ' ' +
            s['c-specialists-photo-round'] : '')}
          style={{ backgroundImage: `url(${imageUrl})` }} />}
      renderError={() => renderEmpty(props.isRoundPhoto) }
    />
    <div className={s['c-specialists-info']}>
      <span className={s['c-specialists-name']}>{props.specialist.title}</span>
      <span className={s['c-specialists-summary']}>{props.getSummary
        ? props.getSummary(props.specialist)
        : props.specialist.offersCount}</span>
    </div>
  </Link>;
